import {InternalError} from './error'
import Is from './is'
import Log from './log'
import Ui from './client-ui'

export default class Network
{
	static init()
	{
		Network.set_action()
	}

	static form_post(form, callback)
	{
		Log.info('Posting form', () =>
		{
			if(!(form instanceof HTMLFormElement)) throw new InternalError('フォームが見つかりません')
			if(form._button === undefined) form._button = $(form).find('input[type="submit"]')

			let action = form._button && form._button.data('action')
			if(action === undefined) action = 'submit'

			$('.__editor').each((index, element) =>
			{
				$(element).data('editor').updateSourceElement()
			})

			if(form._button)
			{
				const custom = form._button.data('confirm-message')

				if(Is.filled(custom))
				{
					if(custom !== 'null' && !confirm(custom)) return
				}
				else
				{
					let confirm = form._button.data('confirm')

					if(confirm === undefined) confirm = 'submit'
					if(confirm !== null && !Ui.confirm(confirm)) return
				}
			}

			const data = new FormData(form)
			data.append('_action', action)

			//Workaround for Quill text editor
			$(form).find('.ui-text-editor').each((index, element) =>
			{
				const name = $(element).data('name')
				if(!Is.filled(name)) return

				data.set(name, $(element).find('.ql-editor').html())
			})

			Network.post(form.action || location.pathname, data, callback)
		})

		return false
	}

	static post(url, data, callback, notify = true)
	{
		(async () =>
		{
			try
			{
				let response = await $.ajax({
					url   : url,
					method: 'POST',

					data: data,

					contentType: false,
					processData: false,
				})

				if(typeof response !== 'object') response = {}

				if(typeof response.success !== 'boolean') response.success = false
				if(typeof response.message !== 'string') response.message = '(メッセージがありません)'

				if(!response.success)
				{
					if(notify) Ui.warning(response.message)
				}
				else
				{
					if(!Is.filled(response.message)) response.message = '更新しました'
					if(notify && response.message !== null) Ui.success(response.message)
				}

				if(typeof callback === 'function') callback(response.success, response.message)
			}
			catch(exception)
			{
				let error = exception.message !== undefined ? exception.message : `HTTP ${exception.status} : エラーが発生しました`
				if(notify) Ui.warning(error)
			}
		})()
	}

	static reset()
	{
		location.href = location.pathname
	}

	static set_action()
	{
		//noinspection JSDeprecatedSymbols
		$('input[type="submit"]').on('click', function()
		{
			if(this.form) this.form._button = $(this)
		})
	}
}
